module.exports = __webpack_public_path__ + "static/media/square-powered.5cb3bd97.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/square-powered.png
// module id = 643
// module chunks = 1